<template>
  <div id="testsuiteView">
    <div v-if="$route.name === 'testsuite'">
      <b-col lg="8" style="padding-left: 0px;">

        <h1>{{ $t('privatePage.testsuite_create_header') }}</h1>
        <test-suite-editor :standardTestMethods="standardTestMethods"
                           :customerTestMethods="customerTestMethods"
                           v-on:onSubmit="onSubmit"
                           :key="nrOfTestSuitesSubmitted"
        ></test-suite-editor>

      </b-col>

      <b-modal id="testSuiteModal" v-model="showTestSuiteModal" hide-footer ref="testSuiteModal" no-close-on-backdrop>
        <template #title>
          <h1 class="modalHeader">{{$t('save_ok_feedback')}}</h1>
        </template>
        <participants-table :participants="modalInfo.participants" :selectedTestType="modalInfo.selectedTestType"></participants-table>
      </b-modal>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TestSuiteEditor from '../../components/testsuite/testsuiteeditor'
import ParticipantsTable from '../../components/testsuite/testsuiteparticipantstable'

export default {
  components: {
    TestSuiteEditor,
    ParticipantsTable
  },
  data() {
    return {
      nrOfTestSuitesSubmitted: 0,
      customerTestMethods: [],
      standardTestMethods: [],
      modalInfo: {
        participants: [],
        selectedTestType: ''
      },
      showTestSuiteModal: false
    }
  },
  computed: {
    ...mapGetters('testMethodsModule', ['activeStandardTestMethods']),
    ...mapGetters('userGroupsModule', [
      'currentGroup',
      'defaultResellerGroupId',
      'defaultCustomerTypeId',
      'defaultCustomerTypeName',
      'userCompany'
    ])
  },
  created() {
    this.getAvailableTestMethods(this.userCompany.id).then(response => {
      this.standardTestMethods = response.length ? response : []
    })
    this.getCustomerTags()
    this.getCustomTestMethods().then(response => {
      this.customerTestMethods = response.length ? response : []
    })
  },
  methods: {
    ...mapActions('testSuitesModule', { saveTestSuite: 'saveTestSuite' }),
    ...mapActions('testMethodsModule', {
      getActiveStandardTestMethods: 'getActiveStandardTestMethods'
    }),
    ...mapActions('userGroupsModule', {
      getAvailableTestMethods: 'getAvailableTestMethods',
      getCustomTestMethods: 'getCustomTestMethods',
      getCustomerTags: 'getCustomerTags',
      getMailTemplates: 'getMailTemplates'
    }),
    ...mapActions({
      showErrorMessage: 'showErrorMessage',
      showSuccessMessage: 'showSuccessMessage'
    }),
    onSubmit(formData) {
      this.saveTestSuite(formData)
        .then(() => {
          this.showSuccessMessage(this.$t('save_ok_feedback'))
          this.modalInfo.participants = formData.participants
          this.modalInfo.selectedTestType = formData.testType
          this.showTestSuiteModal = true
          this.nrOfTestSuitesSubmitted++
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    }
  }
}
</script>
